import { EModalType, IBankInfoModalContent, IBuilderInfoModalContent, IModalContent, TOfferType } from '../../../types';
import { BankInfoModalContent } from '../components/BankInfoModalContent';
import { BuilderInfoModalContent } from '../components/BuilderInfoModalContent';
import { redirect } from '../../../utils';

interface IGetModalContentComponentByType {
  type: TOfferType | null;
  content: IModalContent | null;
  isAuthorized: boolean;
  handleOpenAuthModal: (redirectUrl: string) => void;
}

const getBankModalContent = (
  content: IBankInfoModalContent,
  isAuthorized: boolean,
  handleOpenAuthModal: (redirectUrl: string) => void,
) => {
  const handleClick = () => {
    if (isAuthorized) {
      redirect(content.button.url);
    } else {
      handleOpenAuthModal(content.button.url);
    }
  };

  return <BankInfoModalContent onClick={handleClick} creditInfo={content} />;
};

const getBuilderModalContent = (content: IBuilderInfoModalContent) => {
  return <BuilderInfoModalContent creditInfo={content} />;
};

export const getModalContentComponentByType = ({
  type,
  content,
  isAuthorized,
  handleOpenAuthModal,
}: IGetModalContentComponentByType) => {
  if (!content) {
    return null;
  }

  switch (type) {
    case EModalType.BANK:
      return getBankModalContent(content as IBankInfoModalContent, isAuthorized, handleOpenAuthModal);
    case EModalType.BUILDER:
      return getBuilderModalContent(content as IBuilderInfoModalContent);
    default:
      console.error('Unknown modal type: getModalContentComponentByType');

      return null;
  }
};
